<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>No Product Mapped</title>
    <style>
        body {
            background-color: #f9f9f9;
            font-family: Arial, sans-serif;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            margin: 0;
        }

        .message {
            text-align: center;
            color: #555;
            font-size: 24px;
            border: 2px dashed #ccc;
            padding: 40px;
            border-radius: 12px;
            background-color: #fff;
        }
    </style>
</head>

<body>
    <div class="message d-flex flex-column">
        <b>
            Access Denied or Unauthorized
        </b>
        <small style="display:block; margin: 10px 0; color: #888;">You do not have permission to view this page.</small>
        <p>
            If you believe this is a mistake, please contact your administrator for assistance.
        </p>
        <a href="/login">Back To Login</a>
    </div>
</body>

</html>